import React, { useEffect, useState } from 'react'
import { conferirLink } from './comum'

interface Props {
  valor: string
  aoMudar: (v: string) => void
  /** O dataset que o relatório usa, achado ao conferir o link do relatório. */
  doRelatorio?: { caminho: string; nome?: string | null } | null
  /** Caminho conferido (groups/{ws}/datasets/{id}), ou nulo enquanto não estiver certo. */
  aoConferir: (caminho: string | null) => void
  classe: string
}

/** Dataset do relatório Power BI: obrigatório. Vem preenchido com o do relatório; dá para colar outro. */
export default function CampoDataset({ valor, aoMudar, doRelatorio, aoConferir, classe }: Props) {
  const [achado, setAchado] = useState<{ caminho: string; nome: string } | null>(null)
  const [erro, setErro] = useState<string | null>(null)
  const [conferindo, setConferindo] = useState(false)
  const doProprio = !!doRelatorio && valor.trim() === doRelatorio.caminho

  useEffect(() => {
    setAchado(null); setErro(null)
    if (!valor.trim() || doProprio) return
    const t = setTimeout(async () => {
      setConferindo(true)
      const r = await conferirLink(valor)
      setConferindo(false)
      if (typeof r === 'string') setErro(r)
      else if (r.tipo !== 'html') setErro('Esse link é de um relatório. Cole o link do modelo semântico (dataset).')
      else setAchado({ caminho: r.caminho, nome: r.nome })
    }, 500)
    return () => clearTimeout(t)
  }, [valor, doProprio])

  const conferido = doProprio ? doRelatorio!.caminho : achado?.caminho || null
  useEffect(() => { aoConferir(conferido) }, [conferido]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <label className={classe}>
      <span>Dataset (modelo semântico)</span>
      <input value={valor} onChange={e => aoMudar(e.target.value)} placeholder="Vem do relatório; ou cole o link do modelo semântico no Power BI" />
      {doProprio && <small className="ok" style={{ color: '#2f8a46', fontWeight: 700 }}>O do relatório: {doRelatorio!.nome || 'dataset encontrado'}</small>}
      {!doProprio && conferindo && <small>Conferindo no Power BI…</small>}
      {!doProprio && achado && <small className="ok" style={{ color: '#2f8a46', fontWeight: 700 }}>Encontrado no Power BI: {achado.nome}</small>}
      {!doProprio && erro && <small className="erro" style={{ color: '#c4362b', fontWeight: 700 }}>{erro}</small>}
      {!valor.trim() && <small>Obrigatório. O portal usa para saber quando os dados foram atualizados.</small>}
    </label>
  )
}
